import { getContext } from '@fiverr-private/fiverr_context';
import { currencyFormat } from '@fiverr-private/localization';
import { Currency } from '../types';

export const DEFAULT_CURRENCY = 'USD';

export const dollarsToCurrency = (usd: number, currency: Currency | null): string => {
    const cents = usd * 100;
    return centsToCurrency(cents, currency);
};

export const centsToCurrency = (usdCents: number, currency?: Currency | null): string => {
    const { currency: _contextCurrency = DEFAULT_CURRENCY } = getContext();
    const contextCurrency = _contextCurrency ? _contextCurrency : DEFAULT_CURRENCY;
    const amountInDollars = usdCents / 100;
    const defaultAmount = amountInDollars % 1 === 0 ? amountInDollars : amountInDollars.toFixed(2);

    const fallbackValue = `$${defaultAmount.toLocaleString()}`;
    if (!currency || !currency.rate) return fallbackValue;

    const currencyCode = currency?.name || contextCurrency;
    const value = amountInDollars * currency?.rate;
    const hasFractionDigits = value % 1 !== 0;

    return currencyFormat({
        value,
        currencyCode,
        options: {
            fallbackValue,
            minimumFractionDigits: hasFractionDigits ? 2 : 0,
            maximumFractionDigits: 2,
        },
    }).toString();
};
